<template>
  <div :class="rootClasses" :style="rootStyles">
    <ElementControls
      v-if="editing"
      :no-page-break="!pageBreakAllowed"
      @delete="$emit('delete')"
      @duplicate="$emit('duplicate')"
      @page-break="$emit('page-break')"
      @hide="$emit('hide')"
    />
    <AnalyticsWrapper>
      <div :class="layoutClasses">
        <div
          v-if="label || description"
          class="formester-label-description-wrapper"
          :style="labelDescriptionWrapperStyles"
        >
          <label
            :class="labelClasses"
            :style="labelStyles"
            :for="item.label + item.id"
            v-html="label"
          />
          <SmartText
            :active="active"
            :editing="editing"
            :item="item"
            :style="descriptionStyles"
            :text="description"
          />
        </div>

        <div class="full-flex">
          <template v-for="(subItem, idx) in item.children">
            <div v-if="subItem.active" :key="idx" class="field-wrapper">
              <label
                :style="subLabelStyle(subItem.label)"
                :for="subItem.label"
                :class="
                  subLabelClasses(
                    item.required &&
                      subItem.required &&
                      item.showRequriredMarkOnChildren,
                  )
                "
                >{{ subItem.label }}</label
              >
              <input
                :id="subItem.label"
                v-model="subItem.value"
                :data-uuid="subItem.id"
                :readonly="editing"
                :class="inputClasses"
                :name="`${item.label}_${subItem.label}`"
                :required="item.required && subItem.required"
                :style="inputStyles"
                :placeholder="subItem.placeholder"
                :disabled="isDisabled"
              />
              <ErrorMessage :item="subItem" />
            </div>
          </template>
        </div>
      </div>
    </AnalyticsWrapper>
  </div>
</template>

<script>
import ElementControls from "./element-controls.vue";
import commonStyles from "./mixins/commonStyles";
import sharedActions from "./mixins/sharedActions";
import ErrorMessage from "./error-message.vue";
import SmartText from "./shared/smart-text.vue";
import AnalyticsWrapper from "./analytics-wrapper.vue";

export default {
  name: "Name",
  components: {
    ElementControls,
    ErrorMessage,
    SmartText,
    AnalyticsWrapper,
  },
  mixins: [commonStyles, sharedActions],
  props: {
    item: {
      type: Object,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    styling: {
      type: Object,
      required: true,
    },
    pageBreakAllowed: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["delete", "page-break", "duplicate", "hide"],
  computed: {
    inputClasses() {
      return {
        "formester-input": true,
        "formester-input__name": true,
      };
    },
  },
  methods: {
    subLabelStyle(subLabel) {
      return {
        ...this.subLabelStyles,
        margin: !subLabel && "0px",
      };
    },
  },
};
</script>

<style>
.alone-field-wrapper {
  width: 100%;
}

.full-flex {
  display: flex;
  width: 100%;
  gap: 19px;
}

.field-wrapper {
  width: 100%;
}

.field-wrapper:last-child {
  margin-right: 0;
}

@media screen and (max-width: 540px) {
  .full-flex {
    flex-direction: column;
    gap: 8px;
  }
}

@container (max-width: 480px) {
  .full-flex {
    flex-direction: column;
    gap: 8px;
  }
}
</style>
